module.exports = __webpack_public_path__ + "img/innerCard.829213ed.png";